import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbService, BreadcrumbUrls} from '../../../providers/services/breadcrumb.service';
import {PathNames, Paths, StaticPage, StaticPageContent} from '../../../../config/config';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';
import {CatalogService} from '../../../providers/services/catalog.service';
import {forkJoin, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../../../providers/services/api.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ComparisonComponent} from '../../../components/modals/comparison/comparison.component';
import {PagesService} from '../../../providers/services/pages.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit, OnDestroy {

  @ViewChild(SwiperDirective, {static: false}) swiperDirective: SwiperDirective;

  public readonly PATH_NAME = PathNames[Paths.Products];
  public readonly Paths = Paths;
  private readonly subscriptions: Subscription = new Subscription();

  items;
  itemInEvidence;
  kitseries;
  staticData;
  public readonly staticPageContent = StaticPageContent[StaticPage.Products];

  public readonly config: SwiperConfigInterface = {
    autoplay: false,
    loop: false,
    freeMode: false,
    spaceBetween: 0,
    breakpointsInverse: true,
    navigation: false,
    mousewheel: false,
    slidesPerView: 1
  };

  constructor(private catalogService: CatalogService, private breadcrumbService: BreadcrumbService,
              private apiService: ApiService, private modalService: NgbModal, private pageService: PagesService) {
    breadcrumbService.next(
      BreadcrumbUrls.instance
        .addUrl({link: Paths.Products, label: this.PATH_NAME})
    );

    this.subscriptions.add(
      this.apiService.translateApi(
        locale => forkJoin([
          this.pageService.getPageWithLocale(StaticPage.Products, locale),
          this.catalogService.getProductsWithLocale(locale).pipe(map(({body: {data: {products}}}) => products)),
          this.catalogService.getKitseriesWithLocale(locale).pipe(map(({body: {data: {kitseries}}}) => kitseries)),
          this.catalogService.getProductInEvidenceWithLocale(locale).pipe(map(({body: {data: {product}}}) => product))
        ])
      ).subscribe(([staticData, products, kitseries, product]) => {
        this.staticData = staticData.body.data.contents;
        this.items = products;
        this.kitseries = kitseries;
        this.itemInEvidence = product;
        if (this.swiperDirective) {
          this.swiperDirective.update();
        }
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.breadcrumbService.reset();
    this.subscriptions.unsubscribe();
  }

  openComparison() {
    const ref = this.modalService.open(ComparisonComponent, {
      backdropClass: 'modals-backdrop-custom',
      windowClass: 'comparison-window'
    });
    ref.componentInstance.products = this.items;
    ref.componentInstance.staticData = this.staticData[this.staticPageContent.modalComparator];
  }
}
